import types from './types'

export default {
    [types.SET_VALIDATION_MESSAGES](state, validationMessages) {
        state.validationMessages = [...new Map([...state.validationMessages, ...validationMessages].map(x => [x.id, x])).values()]
    },
}